import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import zeplinColor from 'theme/Color';

const Section = ({ children, title }: { children: ReactNode; title: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        gap: '16px',
        backgroundColor: zeplinColor.Neutral2,
        borderRadius: '14px',
      }}
    >
      <Typography variant='responsiveHeading4'>{title}</Typography>
      {children}
    </Box>
  );
};

export default Section;
